export const FOLDER_STATES = [
    {
        name: 'En cours de Création',
        value: 'EK_FOLDER_CREATED',
        order: 1,
        color: '#ffcc43'
    },
    {
        name: 'en cours de traitement',
        value: 'EK_FOLDER_IN_PROGRESS',
        order: 2,
        color: '#58855C'
    },
    {
        name: 'Réserve interne',
        value: 'EK_FOLDER_RESERVE',
        order: 3,
        color: '#f39c12'
    },
    {
        name: 'Rejeté interne',
        value: 'EK_FOLDER_REFUSED',
        order: 4,
        color: '#e74c3c'
    },
    {
        name: 'Consultation Central Risque',
        value: 'CENTRAL_RISK_CONSULTATION',
        order: 5,
        color: '#5746f6'
    },
    {
        name: 'Notification Client Centrale des Risques',
        value: 'CLIENT_CENTRAL_RISK_NOTIFICATION',
        order: 6,
        color: '#8e44ad'
    },
    {
        name: 'Pré-Notification Banque',
        value: 'EK_BANK_IN_PROGRESS',
        order: 7,
        color: '#2980b9'
    },
    {
        name: 'Notiﬁcation Banque (Accord)',
        value: 'BANK_NOTIFICATION',
        order: 8,
        color: '#f4d03f'
    }, // en attente de création de compte
    {
        name: 'Réserve Banque',
        value: 'EK_BANK_RESERVE',
        order: 9,
        color: '#f39c12'
    }, {
        name: 'Rejeté Banque',
        value: 'EK_BANK_REFUSED',
        order: 10,
        color: '#f39c12'
    },
    {
        name: 'Emission Facture & BL',
        value: 'EK_GUARTENTEES_PENDING_SIGNATURE',
        order: 11,
        color: '#16a085'
    },
    {
        name: 'Réception et validation des garanties',
        value: 'EK_GUARTENTEES_SIGNED_IN_PROGRESS',
        order: 12,
        color: '#2ecc71'
    },
    {
        name: 'Garanties signés en cours validation (Banque) ',
        value: 'EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS',
        order: 13,
        color: '#ffcc43'
    },
    {
        name: 'Confirmation Paiement Banque',
        value: 'BANK_PAYMENT_CONFIRMATION',
        order: 14,
        color: '#58d68d'
    },
    {
        name: 'Dossiers financés',
        value: 'FINANCIAL_FOLDER',
        order: 15,
        color: '#98bd20'
    },
    {
        name: 'Control dossier Physique Banque',
        value: 'EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS',
        order: 16,
        color: '#009dcc'
    },
    {
        name: 'Dossier physique accepté banque ',
        value: 'EK_BANK_PHYSICAL_FOLDER_ACCEPTED',
        order: 17,
        color: '#198038'
    },
    {
        name: 'Dossier physique réserve banque',
        value: 'EK_BANK_PHYSICAL_FOLDER_RESERVE',
        order: 18,
        color: '#f8c471'
    },
    {
        name: 'Dossier physique rejeté banque',
        value: 'EK_BANK_PHYSICAL_FOLDER_REFUSED',
        order: 19,
        color: '#e74c3c'
    }
    ,
    {
        name: 'Annulé (admin)',
        value: 'EK_ADMIN_FOLDER_CANCELED',
        order: 20,
        color: '#e74c3c'
    }
    ,
    {
        name: 'Annulé (client)',
        value: 'EK_CLIENT_FOLDER_CANCELED',
        order: 21,
        color: '#e74c3c'
    }

]
